// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D3TEqnaW4ygO9pmD_90x{border:1px solid var(--border-neutral-default);background:var(--background-primary-inverted-primary);height:24px;color:var(--content-primary-primary);border-radius:6px;justify-content:flex-start;align-items:center;padding:3px 8px;font-size:13px;line-height:16px;display:flex}.D3TEqnaW4ygO9pmD_90x .JSzdH4w_83IBG4_fEmna{color:var(--content-primary-tertiary);cursor:pointer;margin-left:4px}.D3TEqnaW4ygO9pmD_90x .APGJVyRMu04mSmNXQA7w{text-overflow:ellipsis;max-width:215px;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tagWrapper": `D3TEqnaW4ygO9pmD_90x`,
	"icon": `JSzdH4w_83IBG4_fEmna`,
	"tagLabel": `APGJVyRMu04mSmNXQA7w`
};
export default ___CSS_LOADER_EXPORT___;
